import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { rootReducers } from './rootReducers';

export type RootState = ReturnType<typeof rootReducers>;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
